import { render, staticRenderFns } from "./SettingsInvoicing.yaml?vue&type=template&id=37c3c730&component"
import script from "./SettingsInvoicing.yaml?vue&type=script&lang=ts&component"
export * from "./SettingsInvoicing.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports